document.addEventListener('submit', async (e) => {
    if (e.target.id !== 'formCrearTipoReferencia') return;
    e.preventDefault();

    const formulario = e.target;
    const btnSubmit  = formulario.querySelector('#btnCrearTipoReferencia');
    const spinner    = formulario.querySelector('#spinner');
    const formData   = new FormData(formulario);

    if (!btnSubmit || !spinner) {
        if (typeof lanzarAlerta === 'function') lanzarAlerta("Faltan parámetros para crear el tipo de referencia.", "alerta-roja");
        return;
    }

    btnSubmit.disabled = true;
    spinner.style.display = 'inline-block';

    try {
        const respuesta = await fetch('/api/configuracion/tipo-referencia/crear', { method: 'POST', body: formData });
        const json      = await respuesta.json();
        const status    = respuesta.status;
        const resultado = json.result;

        if (status !== 200) {
            alert("Error crítico al procesar la solicitud.");
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        if (resultado.hayErrores) {
            resultado.errores.forEach(error => {
                lanzarAlerta(error.mensaje, error.clase);
                const campo = formulario.querySelector(`[name="${error.campo}"]`);
                if (campo) campo.classList.add('inputRojo');
            });
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        } else {
            lanzarAlerta("Tipo de referencia creado correctamente.", "alerta-verde");
            setTimeout(() => { window.location.reload(); }, 800);
        }

    } catch (error) {
        console.error("Error:", error);
        btnSubmit.disabled = false;
        spinner.style.display = 'none';
    }
});
